import React from "react";
import { Input } from "@athena/forge";
import { useTranslation } from "react-i18next";

export interface PasswordInputFieldProps {
  id: string;
  labelKey: string;
  value: string;
  error?: string;
  autoFocus?: boolean;
  onChange: (value: string) => void;
}

const PasswordInputField = ({
  id,
  labelKey,
  autoFocus,
  onChange,
}: PasswordInputFieldProps): React.JSX.Element => {
  const { t } = useTranslation();

  return (
    <div className="fe_u_margin--top-large">
      <p className="fe_c_label fe_u_margin--bottom-xsmall">{t(labelKey)}</p>
      <Input
        id={id}
        type="password"
        required
        autoFocus={autoFocus}
        onChange={(e) => onChange((e.target as HTMLInputElement).value)}
      />
    </div>
  );
};

export default PasswordInputField;
